import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormCheckboxComponent } from '../../../sale/components/form-checkbox/form-checkbox.component';
import { FormDatepickerComponent } from '../../../sale/components/form-datepicker/form-datepicker.component';
import { FormSelectComponent } from '../../../sale/components/form-field-select/form-select.component';
import { FormInputComponent } from '../../../sale/components/form-field/form-input.component';
import { AddressFormGroup } from '../../interfaces/address';
import { ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

@Component({
    selector: 'app-forms-address',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        FormInputComponent,
        FormSelectComponent,
        FormDatepickerComponent,
        FormCheckboxComponent,
    ],
    templateUrl: './forms-address.component.html',
    styleUrl: './forms-address.component.scss',
})
export class FormsAddressComponent {
    @Input({ required: true }) public formGroup!: AddressFormGroup;

    @Input() public title: string | undefined;
}
